import React, { Component } from "react";
import { CSSTransitionGroup } from "react-transition-group";
import PropTypes from "prop-types";
import "./Finished.css";
import Header from "./Header.js";
import Modal from "./Modal.js";
import ScheduleRetro from "./ScheduleRetro.js";
import Motivation from "./Motivation.js";
import SectionLabel from "./SectionLabel.js";
import CircleIcon from "./CircleIcon.js";
import CopyToClipboard from "./CopyToClipboard.js";
import { blogPosts } from "../shared/_constants.js";
import { getSuffix } from "../shared/_utils.js";
import kudosIcon from "../kudos_icon.svg";
import concernsIcon from "../concerns_icon.svg";
import checkmarkIcon from "../checkmark_icon.svg";

class Finished extends Component {
  constructor() {
    super();
    this.state = {
      showScheduleModal: false,
      copyToClipboard: false,
    };
  }

  openCloseScheduleModal = bool => {
    this.setState({
      showScheduleModal: bool,
    });

    if (bool) {
      window.analytics.track("Opens Schedule Retro Popup");
    }
  };

  openShareWindow = () => {
    let shareMessage =
      "My team just finished our " +
      getSuffix(this.props.retroSessions.length) +
      " Outro and we're feeling the 💪. We gave " +
      this.props.retroSessions[0].kudosGiven +
      " kudos, and discussed " +
      this.props.retroSessions[0].concernsAdded +
      " new concerns. via: https://outro.co";
    let encodedShareMessage = encodeURIComponent(shareMessage);

    let height = 350;
    let width = 600;
    let left = window.innerWidth / 2 - width / 2;
    let top = window.innerHeight / 2 - height / 2;
    window.open(
      "https://twitter.com/intent/tweet?text=" + encodedShareMessage,
      "twitter-popup",
      `height=${height},width=${width},left=${left},top=${top}`
    );

    window.analytics.track("Opens Twitter Share Popup");
  };

  copyToClipboard = () => {
    this.setState({
      copyToClipboard: true,
    });

    setTimeout(() => {
      this.setState({
        copyToClipboard: false,
      });
    }, 5000);

    window.analytics.track("Copies Email to Clipboard", {
      source: "finished page",
    });
  };

  render() {
    return (
      <div>
        <Modal
          showScheduleModal={this.state.showScheduleModal}
          openCloseScheduleModal={this.openCloseScheduleModal}
        >
          <h1 className="modal-title">Schedule Outro</h1>
          <ScheduleRetro
            settings={this.props.settings}
            commitUpdatedSettings={this.props.commitUpdatedSettings}
          />
        </Modal>
        <Header
          user={this.props.user}
          freeRetros={this.props.freeRetros}
          payment={this.props.payment}
        />
        <div className="finished-container">
          <CSSTransitionGroup
            transitionName="sun-transition"
            transitionAppear={true}
            transitionAppearTimeout={3000}
            transitionEnterTimeout={3000}
            transitionLeaveTimeout={0}
          >
            <div className="sun" />
          </CSSTransitionGroup>
          <CSSTransitionGroup
            component="div"
            className="finished-content-container"
            transitionName="content-transition"
            transitionAppear={true}
            transitionAppearTimeout={5000}
            transitionEnterTimeout={5000}
            transitionLeaveTimeout={0}
          >
            <div className="two-box-container">
              <div className="motivation-container">
                <Motivation
                  retroSessions={this.props.retroSessions}
                  type="finished"
                />
                <div
                  className="schedule-next"
                  onClick={() => this.openCloseScheduleModal(true)}
                >
                  Schedule Next Outro
                </div>
              </div>
              <div className="metrics-container">
                <SectionLabel text="TODAY'S METRICS" />
                <div className="metrics">
                  <div className="weekly">
                    <div className="kudos">
                      <img className="icon" src={kudosIcon} alt="kudos-icon" />
                      <div className="count">
                        {this.props.retroSessions[0].kudosGiven}
                      </div>
                      <div className="text">kudos given</div>
                    </div>
                    <div className="divider" />
                    <div className="new-concerns">
                      <img
                        className="icon"
                        src={concernsIcon}
                        alt="concerns-icon"
                      />
                      <div className="count">
                        {this.props.retroSessions[0].concernsAdded}
                      </div>
                      <div className="text">concerns added</div>
                    </div>
                    <div className="divider" />
                    <div className="completed-concerns">
                      <img
                        className="icon"
                        src={checkmarkIcon}
                        alt="checkmark-icon"
                      />
                      <div className="count">
                        {this.props.retroSessions[0].concernsCompleted}
                      </div>
                      <div className="text">concerns completed</div>
                    </div>
                  </div>
                  <div className="total-completed">
                    <div className="text">total concerns completed</div>
                    <div className="count">
                      {this.props.retroSessions[0].totalConcernsCompleted}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="next-steps-container">
              <div className="makers">
                <a
                  className="link-container"
                  href={blogPosts.introToOutro}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    window.analytics.track("Opens Blog Post", {
                      post: "intro to outro",
                    });
                  }}
                >
                  <CircleIcon type="medium" />
                  <h1>Our Story</h1>
                </a>
                <p>
                  Read more about why we built Outro, our inspiration, and our
                  mission.
                </p>
              </div>
              <div className="share">
                <div className="link-container" onClick={this.openShareWindow}>
                  <CircleIcon type="twitter" />
                  <h1>Share Outro</h1>
                </div>
                <p>
                  Spread the positivity and help us get the word out about
                  Outro.
                </p>
              </div>
              <div className="contact">
                <CopyToClipboard copyToClipboard={this.state.copyToClipboard} />
                <div className="link-container" onClick={this.copyToClipboard}>
                  <CircleIcon type="contact" />
                  <h1>Email Us</h1>
                </div>
                <p>
                  Get in touch if you have any feedback, problems, or just want
                  to say hello.
                </p>
              </div>
            </div>
          </CSSTransitionGroup>
        </div>
      </div>
    );
  }
}

Finished.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    uid: PropTypes.string.isRequired,
    creationTime: PropTypes.string.isRequired,
    lastSignInTime: PropTypes.string.isRequired,
    photoURL: PropTypes.string,
  }).isRequired,
  retroSessions: PropTypes.array.isRequired,
  freeRetros: PropTypes.number.isRequired,
  payment: PropTypes.shape({
    activeSubscription: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    stripeCustomerID: PropTypes.string.isRequired,
  }),
};

export default Finished;



// WEBPACK FOOTER //
// ./src/components/Finished.js